export enum ReportFooterType {
  SUM = 'SUM',
  AVERAGE = 'AVERAGE',
  BOOTH = 'BOOTH',
}

export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  PDF = 'PDF',
}

export interface ListReferenceColorDTO {
  id: string;
  name: string;
  hexcode: string;
}

export interface ReportProductColorClassificationType {
  classification: string;
  classificationTypeId: string;
}
